import { Draggable } from '@neodrag/vanilla';
import BaseClass from './BaseClass';
import TempCache from './enums/TempCache';
import WidgetsCache from './WidgetsCache';
import LoadJsCssFile from './files/LoadJsCssFile';
import { WidgetCreator } from './WidgetCreator';
import GlobalVariables from './GlobalVariables';
import resetCSS from './hooks/resetCSS';
import addStyleText from './hooks/addStyleText';
import getCookieValue from './hooks/getCookieValue';
import CreateGuid from '../../CreateGuid';
import isMobile from '../isMobile';

export default class BaseWidgetClient extends BaseClass {
    /** METHODS FOR COMMON LIFE-CYCLE LOGIC* */
    constructor(options) {
        super(options);
        const me = this;
        // no need for this as our super-most class (BaseClass) has made me.$ available for us all:-)
        // me.extend_$();
        me.options = options;
        me.options.greetVideoURL = `${GlobalVariables.ApexChatBaseUrl}greetVideos/greet.webm`;
        me.options.greetVideoText = "Hey, let's watch the intro";
        me.options.greetVideoStartChat = "Let's get started";
        me.widget = options && options.widget ? options.widget : 'n/a';
        me.handlesAll = options && options.handlesAll;
        me.notifiesAll = options && options.notifiesAll;
        me.widgetId = options && options.widgetId ? options.widgetId : CreateGuid();
        me.iframeId = options && options.iframeId ? options.iframeId : CreateGuid();
        me.parentDivId = options && options.parentDivId ? options.parentDivId : CreateGuid();
        me.elDragnDrop = options && options.elDragnDrop ? options.elDragnDrop : null;
        me.elDragnDropCss = options && options.elDragnDropCss ? options.elDragnDropCss : '';
        me.isDraggable = false;
        // me.listenForMessages(); // JIRA_4283 - Due to this function PostMessage was running twice.
        me.widgetScripts = [];
        me.widgetCss = [];
        const popOut = function (args) {
            /// /me.options.chatInitiatedBy = 'ExitPopup';
            /// /me.startWindowedChat(me.options);
        };
        // push default css and scripts here for all widgets
        // this.widgetScripts.push('https://cdn.jsdelivr.net/lodash/4/lodash.min.js');
        // this.widgetCss.push('https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css');
        // this.log('client created for ' + self.widget);
        WidgetsCache.register(me.widget, this);
        // Adding custom (Advance css) on visitor page to override iframe position, width and height
        if (options.customIFrameWrapperCss) {
            addStyleText(
                this.options.customIFrameWrapperCss,
                'apexchat_iframe_custom_css'
            );
        }
        //if (options.v3DefaultStyles) {
        // addStyleText(this.options.v3DefaultStyles, 'apexchat_v3_default_css');
        // }
    }

    ready() {
        const me = this;
    }

    create() {
        const me = this;
        const wrapper = document.createElement('div');
        wrapper.setAttribute('id', me.parentDivId);
        wrapper.setAttribute('class', `${me.widget}_wrapper`);
        wrapper.setAttribute('class', `${me.widget}_wrapper_custom`);
        wrapper.setAttribute('style', `z-index:${TempCache.CONTAINER_Z_INDEX}`);
        wrapper.style.background = me.options.containerBg;
        me.$container = wrapper;
    }

    async show() {
        const me = this;
        const iframeHtml = me.getIframeBodyTemplate();
        const iframe = document.getElementById(me.iframeId);
        let frameDoc = iframe.document;
        if (iframe.contentWindow) {
            frameDoc = iframe.contentWindow.document; // IE
        }
        if (isMobile()) {
            iframe.classList.add('invitation_frame_mobile');
        }
        frameDoc.open();
        frameDoc.close();
        me.widgetCss.forEach((item, index) => {
            LoadJsCssFile(item, 'css', frameDoc, true);
        });
        me.widgetScripts.forEach((item, index) => {
            LoadJsCssFile(item, 'js', frameDoc);
        });
        if (me.elDragnDrop) {
            me.makeDraggable();
        }
        resetCSS(me.iframeId, { trimWhiteSpaces: true });
        const widgetCreator = new WidgetCreator();
        me.options.isPageRefreshed = this.isPageRefreshed();
        await widgetCreator.create(me.options);
    }

    /** METHODS FOR STATE MANAGEMENT * */
    getLastRenderedState() {
        // ZEE: this must be tested against each widget type!
        const store = this.state.retrieve();
        const stateLog = store.history;
        const stateTransitions = stateLog.length;
        const state = stateLog[stateTransitions - 1];
        return state;
    }

    isChatInProgress() {
        return (getCookieValue(TempCache.CHAT_ID_COOKIE) || 0) > 0;
    }

    /** UTIL METHODS * */
    getIframeBodyTemplate() {
        const me = this;
        const widgetKey = me.options.widget.split('_')[1];
        let templateText = '<html><head>';
        me.widgetCss.forEach((item, index) => {
            templateText += `<link rel="stylesheet" type="text/css" href="${item}"></script>`;
        });
        me.widgetScripts.forEach((item, index) => {
            templateText += `<script async src="${item}"></script>`;
        });
        templateText += '</head><body>';
        // templateText += '<script>parent.ApexChat.createWidget.call(this, ' + JSON.stringify(me.options) + ');</script>';
        // templateText += '<script>$(document).ready(function(){alert("ready");});</script>';
        templateText += '</body></html>';
        return templateText;
    }

    makeDraggable() {
        const me = this;
        setTimeout(() => {
            const dragInstance = new Draggable(document.querySelector(`#${me.parentDivId}`));
        }, 0);
    }

    setupWiggling(timeout) {
        let defaultTimeout = this.options.wiggleInterval;
        if (timeout !== undefined) {
            defaultTimeout = timeout;
        }
        setTimeout(this.startWiggling, defaultTimeout, this);
    }

    startWiggling(ctx) {
        const me = ctx;
        me.animator.wiggleElement({
            element: me.parentDivId,
            position: me.isPageRefreshed() ? me.options.secondaryPosition : me.options.position
        });
        ApexChat.wigglingTimeouts = setTimeout(
            me.startWiggling,
            me.options.wiggleInterval + me.options.animationTime,
            me
        );
    }

    stopWiggling() {
        clearTimeout(ApexChat.wigglingTimeouts);
    }
}
// Export to window
